module.exports = __webpack_public_path__ + "img/9.6578c12c.png";